import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { MenuItem } from 'material-ui';
import { length, required } from 'redux-form-validators';
import { TextField, SelectField } from 'redux-form-material-ui';

import gmtData from 'data/gmt';
import { formName } from 'data/formNames';
import { getCountries } from "actions/countries";

import Coordinates from './Coordinates';
import ErrorBoundary from './ErrorBoundary';
import ServiceProviders from './ServiceProviders';
import PortRestrictions from './PortRestrictions';
import Facilities from './Facilities';
import Warehouses from './Warehouses';
import LiftAndCranes from './LiftAndCranes/List';

const styles = {
    textField: {
        floatingLabelStyle: {
            fontSize: '12px',
        },
    },
    btn: {
        addServiceProvider: {
            style: {
                margin: '20px 0 70px 0'
            },
        },
        labelStyle: {
            color: '#fff', textTransform: 'none', fontSize: '13px',
        },
        style: {
            margin: '20px 0'
        },
    },
};

/**
 * @typedef {{
 *  handleSubmit: () => void,
 *  change: (name: string, value: any) => void,
 *  countries: any[],
 *  getCountries: () => void;
 * }} Props
 * @type {import('react').FC<Props>}
 */
const PortAddForm = ({ handleSubmit, change, countries, getCountries }) => {
    useEffect(() => {
        getCountries();
    }, []);

    return (
        <form autoComplete="off" className={'main add-port'} onSubmit={handleSubmit}>
            <div className="main__title">Coordinates</div>

            <Coordinates change={change} />

            <div className="main__title">Main info</div>

            <div className="row">
                <div className="col-xs-3">
                    <Field
                        component={TextField}
                        name={'name'}
                        validate={[required(), length({ min: 3})]}
                        floatingLabelText='Name'
                        floatingLabelStyle={styles.textField.floatingLabelStyle}
                        fullWidth
                    />
                </div>
                <div className="col-xs-3">
                    <Field
                        component={SelectField}
                        name={'country._id'}
                        floatingLabelText='Country'
                        floatingLabelStyle={styles.textField.floatingLabelStyle}
                        autoWidth
                        fullWidth
                        validate={required()}
                        onChange={(e, value) => {
                            e.preventDefault();

                            change('country', countries.find((country) => {
                                return country._id === value;
                            }));
                        }}
                    >
                        {
                            countries.map((country, key) => (
                                <MenuItem
                                    key={key}
                                    value={country._id}
                                    primaryText={country.name}
                                />
                            ))
                        }
                    </Field>
                </div>

                <div className="col-xs-3">
                    <Field
                        component={TextField}
                        name={'unLoCode'}
                        validate={[ length({ max: 5}) ]}
                        floatingLabelText='UN LOCODE'
                        floatingLabelStyle={styles.textField.floatingLabelStyle}
                        fullWidth
                    />
                </div>

                <div className="col-xs-3">
                    <Field
                        component={SelectField}
                        name={'timezone'}
                        floatingLabelText='timezone'
                        floatingLabelStyle={styles.textField.floatingLabelStyle}
                        fullWidth
                    >
                        {
                            gmtData.map((gmt, key) => (
                                <MenuItem
                                    key={key}
                                    value={gmt}
                                    primaryText={gmt}
                                />
                            ))
                        }
                    </Field>
                </div>

                <div className="col-xs-3">
                    <Field
                        component={TextField}
                        name={'site'}
                        floatingLabelText='Web site'
                        floatingLabelStyle={styles.textField.floatingLabelStyle}
                        fullWidth
                        validate={[ length({ min: 8, allowBlank: true })]}
                    />
                </div>
            </div>

            <div className="main__title">SERVICE PROVIDERS</div>
            <ErrorBoundary>
                <FieldArray
                    name={'serviceProviders'}
                    component={ServiceProviders}
                    styles={styles}
                />
            </ErrorBoundary>
            <ErrorBoundary>
                <PortRestrictions styles={styles} />
            </ErrorBoundary>
            <ErrorBoundary>
                <LiftAndCranes />
            </ErrorBoundary>
            <ErrorBoundary>
                <Facilities />
            </ErrorBoundary>
            <ErrorBoundary>
                <Warehouses />
            </ErrorBoundary>
            <ErrorBoundary>
                <div className="main__title">other</div>

                <div className="row">
                    <div className="col-xs-12">
                        <Field
                            name={'additionalDescription'}
                            component={TextField}
                            floatingLabelText='Other'
                            multiLine
                            fullWidth
                            floatingLabelStyle={styles.textField.floatingLabelStyle}
                        />
                    </div>
                </div>
            </ErrorBoundary>
        </form>
    );
};

PortAddForm.displayName = 'PortAddForm';

const PortAddReduxForm = reduxForm({
    form: formName.portCreate,
    enableReinitialize: true,
    asyncBlurFields: ['unLoCode'],
})(/** @type {any} */ (PortAddForm)); // TODO: @types/redux-form should fix this

export default connect(
    /** @param {any} param0 */
    ({ port, countries }) => ({
        countries: countries.items,
        initialValues: { ...port },
    }),
    (dispatch) => bindActionCreators({
        getCountries,
    }, dispatch),
)(PortAddReduxForm);



// WEBPACK FOOTER //
// ./app/components/Regions/PortAdd/PortAddForm.jsx